import Api from '@/api/question'
import {Message, MessageBox} from 'element-ui'

const state = {
  chatType: null,
  model: null
}
const getters = {
  chatType (){
    return state.chatType
  },
  model (){
    return state.model
  },
}
const actions = {
  getEnable ({commit, state}, object) {
    return new Promise((resolve, reject) => {
      Api.getEnable({visitorMd5Code: object.visitorMd5Code}, res => {
        if (res.code === 1) {
          commit('setChatType', res.data.chatType)
          commit('setModel', res.data.model)
          resolve(res.data)
        } else {
          Toast(res.data.message)
        }
      })
    })
  }
}

const mutations = {
  setChatType(state, chatType) {
    state.chatType = chatType
  },
  setModel(state, model) {
    state.model = model
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/question.js